<template>
	<div class="card card-event col-md-3" :id="'event-card-' + event.id">
		<div class="inner-wrapper">
			<img :src="'https://world-architects.com' + event.agenda_image.image_versions.w780" class="img-responsive card-img-top" alt="" v-on:click.prevent="showModal">
			<div class="card-body">
				<h4 class="card-title no-border">
					{{ event.tour }}
				</h4>
				<div class="card-text">
					<!-- {{ event.description | truncate(100) }} -->
					<span v-if="event.guide">{{ event.guide }}<br /></span>
					<div class="event-theme" v-if="event.theme">{{ event.theme }}<br /></div>
					<div class="event-more">
						<a href="#" v-on:click.prevent="showModal">
						<i class="wa-arrow wa-arrow-right wa-arrow-small"></i> {{ $t('event_registration.more_info') }}
					</a>
					</div>
				</div>
				<div class="event-datetime">
					<strong>{{ event.time_span }}</strong>
				</div>
			</div>
			<div style="margin-top: 10px;" class="event-button">
				<a href="#" :class="{btn: true, 'btn-add-attendee': true, 'btn-default': !event.selected, 'btn-selected': event.selected}" :id="'event-card-button-' + event.id" v-on:click.prevent="select" v-if="event.allow_registrations">
					{{ $t('event_registration.attend') }}
				</a>
				<div v-if="!event.allow_registrations" class="btn btn-default btn-add-attendee">
					{{ $t('event_registration.fully_booked') }}
				</div>
			</div>
		</div>

		<event-description-modal :event="event"></event-description-modal>
	</div>
</template>

<script>
import EventDescriptionModal from './EventDescriptionModal';

export default {
	name: 'EventPanel',

	components: {
		EventDescriptionModal
	},

	props: {
		event: {
			required: true,
			type: Object
		}
	},

	methods: {
		select: function () {
			this.$set(this.event, 'selected', !this.event.selected);
		},
		showModal: function() {
			this.$modal.show('event-description-' + this.event.id);
		}
	},

	data: function () {
		return {};
	}
}
</script>

<style>
.card-event {
	/* min-height: 370px; */
	margin-bottom: 40px;
	display: flex;
    flex-wrap: wrap;
}
.card-event .btn-add-attendee {
	width:100%;
	/* position: absolute;  */
	/* bottom: 0; */
	/* left: 0; */
}
.card-event {
	/* position: relative; */
	min-height: 370px;
	display: flex;
    flex-wrap: wrap;
}
.card-event .inner-wrapper .card-body .card-text {
	/* position: relative; */
	min-height: 100px;
}

.card-event img {
	margin-bottom: 10px;
}
.card-event h5 {
	font-weight: bold;
	border-bottom: none;
	margin-bottom: 10px;
}
.event-button {
	align-self: flex-end;
}
.event-theme {
	padding-top: 10px;
}
.event-more {
	padding-top: 10px;
}
.event-datetime {
	padding-top: 10px;
}
</style>
